<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="wfconfigs.wfconfigID > 0 ? '编辑':'新建'"
      class="customer-edit"
      width="1000px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="wfconfigs"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="18">
          <el-form-item label="表单类型">
            <el-radio-group v-model="billType">
              <el-radio
                  v-for="(item,index) in billTypeList"
                  v-if="item.wfName!==''"
                  :key="index"
                  style="margin-bottom: 1%"
                  :label="item.wfName"
                  @change="checkChange(item)">
                {{item.formText}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="节点处理人" prop="handlerEmployeeName">
            <div style="display: flex;flex-direction: row;width: 300px;">
              <el-input v-model="wfconfigs.handlerEmployeeName" placeholder="请输入" disabled>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectUser.open()"/>
              </el-input>
              <!--              <employee-select ref="selectEmployee" @select="onSelectEmployee"/>-->
              <user-select ref="selectUser" @select="selectUser"/>
            </div>
          </el-form-item>
          <el-form-item label="提交部门">
            <div class="tag-group">
              <el-tag
                  v-for="tag in submitDepartmentList"
                  :key="tag.submitName"
                  style="margin-right: 2%"
                  closable
                  :disable-transitions="false"
                  effect="plain"
                  @close="handleDepartmentClose(tag)">
                {{tag.submitName}}
              </el-tag>
              <el-button slot="append" icon="el-icon-plus" @click="$refs.selectDepartment.open()">添加</el-button>
              <department-select ref="selectDepartment" @select="onSelectDepartment"/>
            </div>
          </el-form-item>
          <el-form-item label="客户" prop="handlerValue">
            <div class="tag-group">
              <el-tag
                  v-for="tag in submitCustomerList"
                  :key="tag.submitName"
                  style="margin-right: 2%"
                  closable
                  :disable-transitions="false"
                  effect="plain"
                  @close="handleCustomerClose(tag)">
                {{tag.submitName}}
              </el-tag>
              <el-button slot="append" icon="el-icon-plus" @click="$refs.selectCustomer.open()">添加</el-button>
              <customer-select ref="selectCustomer" @select="onSelectCustomer"/>
            </div>
          </el-form-item>
          <el-form-item label="非客户" prop="handlerValue">
            <div class="tag-group">
              <el-tag
                  v-for="tag in submitUnCustomerList"
                  :key="tag.submitName"
                  style="margin-right: 2%"
                  closable
                  :disable-transitions="false"
                  effect="plain"
                  @close="handleUnCustomerClose(tag)">
                {{tag.submitName}}
              </el-tag>
              <el-button slot="append" icon="el-icon-plus" @click="$refs.onSelectUnCustomer.open()">添加</el-button>
              <customer-select ref="onSelectUnCustomer" @select="onSelectUnCustomer"/>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div>表单节点</div>
            <el-radio-group v-model="wfconfigs.approveNode">
              <el-radio
                  v-for="(item,index) in approveNodeList"
                  :key="index"
                  style="margin-top: 2%"
                  :label="item.approveNodeID"
                  @change="changeApproveNode(item)">
                {{item.descrpt}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name:"WFConfigEdit",
    components: {UserSelect, CustomerSelect, DepartmentSelect},
    data() {
      return {
        constants,
        positionList: [],
        billTypeList: [],
        approveNodeList: [],
        submitDepartmentList: [],
        submitCustomerList: [],
        submitUnCustomerList: [],
        billType: "",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        workFlow: {},
        wfconfigs: {
          approveNode: "",
          billType: "",
          handler: "",
          handlerEmployeeName: "",
          submitType: "",
          submitValue: "",
          wfconfigID: "",
          submitList: [],
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        this.wfconfigs.wfconfigID = id;
        this.dialogVisible = true;
        this.getBillTypeList();
        //this.getPositionList();
        //this.getDepartmentList();
        if (id > 0) {
          this.getData();
        } else {
          this.getWorkFlow("SaleOrder");
        }
      },
      // selectWFConfigNode(id) {
      //   this.wfconfigs.wfconfigID = id;
      // },
      // selectWFConfigDepartment(id) {
      //   this.wfconfigs.wfconfigID = id;
      // },
      getData() {
        this.$http
          .get("basic", `configs/${this.wfconfigs.wfconfigID}`)
          .then(resp => {
            console.log(resp);
            this.wfconfigs = resp;
            for (let item of this.wfconfigs.submitList) {
              if (item.submitType === 0) {
                this.submitDepartmentList.push(item);
              } else if (item.submitType === 1) {
                this.submitCustomerList.push(item);
              } else {
                this.submitUnCustomerList.push(item);
              }
            }
            this.billType = this.wfconfigs.billType.replace(new RegExp("wf", "g"), "").replace(new RegExp("Application", "g"), "");
            this.getWorkFlow(this.billType);
          });
      },
      //部门
      handleDepartmentClose(tag) {
        this.submitDepartmentList.splice(this.submitDepartmentList.indexOf(tag), 1);
      },
      //客户
      handleCustomerClose(tag) {
        this.submitCustomerList.splice(this.submitCustomerList.indexOf(tag), 1);
      },
      //非客户
      handleUnCustomerClose(tag) {
        this.submitUnCustomerList.splice(this.submitUnCustomerList.indexOf(tag), 1);
      },
      onSelectDepartment(row) {
        for (let item of this.submitDepartmentList) {
          if(item.submitValue === row.departmentID) {
            return this.$message.error(row.departmentName + "已存在！");
          }
        }
        let submitObject = {
          submitName: row.departmentName,
          submitType: 0,
          submitValue: row.departmentID,
        };
        this.submitDepartmentList.push(submitObject);
      },
      onSelectCustomer(row) {
        for (let item of this.submitCustomerList) {
          if(item.submitValue === row.customerID) {
            return this.$message.error(row.customerName + "已存在！");
          }
        }
        let submitObject = {
          submitName: row.customerName,
          submitType: 1,
          submitValue: row.customerID,
        };
        this.submitCustomerList.push(submitObject);
      },
      onSelectUnCustomer(row) {
        for (let item of this.submitUnCustomerList) {
          if(item.submitValue === row.customerID) {
            return this.$message.error(row.customerName + "已存在！");
          }
        }
        let submitObject = {
          submitName: row.customerName,
          submitType: 2,
          submitValue: row.customerID,
        };
        this.submitUnCustomerList.push(submitObject);
      },
      getBillTypeList() {
        this.$http
          .get("basic", "forms/selectList")
          .then(resp => {
            console.log(resp);
            this.billTypeList = resp;
          });
      },
      checkChange(item) {
        console.log(item);
        this.wfconfigs.billType = item.wfName;
        this.getWorkFlow(item);
      },
      changeApproveNode(item) {
        this.wfconfigs.approveNode = item.approveNodeID;
      },
      getWorkFlow(item) {
        let val="";
        if (item.wfName==="") {
          val = "wf"+item.formName+"Application";
        }else {
          val = item.wfName;
        }
        this.$http
          .get("basic", `workflows/node/${val}`)
          .then(res => {
            console.log(res);
            this.approveNodeList = res;
          });
      },
      // getApproveNode(id) {
      //   this.$http
      //     .get("basic", `workflows/selectAllApproveNodes/${id}`)
      //     .then(resp => {
      //       this.approveNodeList = resp;
      //     });
      // },
      selectUser(row) {
        console.log(row);
        this.wfconfigs.handlerEmployeeName = row.employeeName;
        this.wfconfigs.handler = row.systemUserID;
      },
      handleSubmit() {
        console.log(this.wfconfigs);
        this.wfconfigs.submitList = [];
        this.wfconfigs.submitList = this.submitDepartmentList.concat(this.submitCustomerList).concat(this.submitUnCustomerList);
        console.log(this.wfconfigs.submitList);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .saveById("basic", "configs", this.wfconfigs,this.wfconfigs.wfconfigID)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
